import { Box, Group, Loader, Text, Title } from '@mantine/core';
import type { ReactNode } from 'react';

interface PageHeaderProps {
  /** Seitentitel */
  title: string;
  /** Kurze Beschreibung unter dem Titel */
  description?: string;
  /** Optionale Aktions-Buttons rechts */
  actions?: ReactNode;
  /** Ladeanzeige rechts */
  loading?: boolean;
}

/**
 * Einheitlicher Seiten-Header für alle Admin-Seiten.
 * Sorgt für konsistentes Layout: Titel + Beschreibung links, Aktionen rechts.
 */
export function PageHeader({ title, description, actions, loading }: PageHeaderProps) {
  return (
    <Group
      justify="space-between"
      align="flex-end"
      pb="sm"
      mb="lg"
      wrap="wrap"
      gap="sm"
      style={{
        borderBottom: '1px solid var(--app-border)',
      }}
    >
      <Box
        style={{
          paddingLeft: 12,
          borderLeft: '3px solid var(--color-primary)',
        }}
      >
        <Title order={2} c="var(--color-text)" style={{ lineHeight: 1.2 }}>
          {title}
        </Title>
        {description && (
          <Text c="dimmed" size="sm" mt={2}>
            {description}
          </Text>
        )}
      </Box>
      <Group gap="xs" align="center">
        {loading && <Loader size="sm" color="brand" />}
        {actions}
      </Group>
    </Group>
  );
}
